import { create } from "zustand";
import { Offer } from "../models/offers";
import { Filters as OfferFiltersType } from "../components/Marketplace/MarketplaceOffers/OfferFilterList";


type MarketplaceState = {
    page: number;
    setPage: (page: number) => void;
    pageSize: number;
    currentParams?: Record<string, any>;
    setCurrentParams: (params: Record<string, any>) => void;
    filteredOffers: Offer[];
    setFilteredOffers: (offers: Offer[] | ((prev: Offer[]) => Offer[])) => void;
    activeTab: string;
    setActiveTab: (tab: string) => void;
    loading: boolean;
    setLoading: (v: boolean) => void;
    err: string;
    setErr: (v: string) => void;
    showFilters: boolean;
    setShowFilters: (v: boolean) => void;
    savedOfferIds: number[];
    setSavedOfferIds: (ids: number[] | ((prev: number[]) => number[])) => void;
    createFormOpen: boolean;
    setCreateFormOpen: (v: boolean) => void;
    currentFilters: OfferFiltersType;
    setCurrentFilters: (filters: OfferFiltersType) => void;
    selectedVertical: string;
    setSelectedVertical: (v: string) => void;
    searchText: string;
    setSearchText: (v: string) => void;

};

export const useMarketplaceStore = create<MarketplaceState>((set) => ({
    page: 1,
    setPage: (page) => set({ page }),
    pageSize: 20,
    currentParams: undefined,
    setCurrentParams: (params) => set({ currentParams: params }),
    filteredOffers: [],
    setFilteredOffers: (offers) =>
        set((state) => ({
            filteredOffers:
                typeof offers === "function" ? offers(state.filteredOffers) : offers,
        })),
    activeTab: "all",
    setActiveTab: (tab) => set({ activeTab: tab }),
    loading: false,
    setLoading: (v) => set({ loading: v }),
    err: "",
    setErr: (v) => set({ err: v }),
    showFilters: false,
    setShowFilters: (v) => set({ showFilters: v }),
    savedOfferIds: [],
    setSavedOfferIds: (ids) =>
        set((state) => ({
            savedOfferIds:
                typeof ids === "function" ? ids(state.savedOfferIds) : ids,
        })),
    createFormOpen: false,
    setCreateFormOpen: (v) => set({ createFormOpen: v }),
    currentFilters: {
        verticals: [],
        payoutRange: { min: "", max: "" },
        state_list: [],
        payout_type: "",
        campaign_types: []

    },
    setCurrentFilters: (filters) => set({ currentFilters: filters }),
    selectedVertical: "All",
    setSelectedVertical: (v) => set({ selectedVertical: v }),
    searchText: "",
    setSearchText: (v) => set({ searchText: v })
}));
